const FinanceTransactions = () => import('./FinanceTransactions.vue')
const FinanceTransactionDetails = () => import('./FinanceTransactionDetails.vue')
const FinanceTransactionConfirm = () => import('./FinanceTransactionConfirm.vue')
const FinanceTransactionTransfer = () => import('./FinanceTransactionTransfer.vue')

export default [
  {
    name: 'finance-transactions',
    path: 'finance-transactions/:type',
    component: FinanceTransactions,
    meta: {
      access: ['org.finance.transaction.expense.view', 'org.finance.transaction.income.view']
    },
    children: [
      {
        name: 'finance-transaction-edit',
        path: 'edit/:financeTransactionId',
        components: {
          modal: FinanceTransactionDetails
        },
        meta: {
          showModal: true,
          access: ['org.finance.transaction.expense.manage', 'org.finance.transaction.income.manage']
        }
      },
      {
        name: 'finance-transaction-confirm',
        path: 'confirm/:financeTransactionId',
        components: {
          modal: FinanceTransactionConfirm
        },
        meta: {
          showModal: true,
          access: ['org.finance.transaction.expense.manage', 'org.finance.transaction.income.manage']
        }
      },
      {
        name: 'finance-transaction-new',
        path: 'new',
        components: {
          modal: FinanceTransactionDetails
        },
        meta: {
          showModal: true,
          access: ['org.finance.transaction.expense.manage', 'org.finance.transaction.income.manage']
        }
      },
      {
        name: 'finance-transaction-new-transfer',
        path: 'new-transfer',
        components: {
          modal: FinanceTransactionTransfer
        },
        meta: {
          showModal: true,
          access: ['org.finance.transaction.expense.manage', 'org.finance.transaction.income.manage']
        }
      },
      {
        name: 'finance-transaction-edit-transfer',
        path: 'edit-transfer/:financeTransactionId',
        components: {
          modal: FinanceTransactionTransfer
        },
        meta: {
          showModal: true,
          access: ['org.finance.transaction.expense.manage', 'org.finance.transaction.income.manage']
        }
      }
    ]
  }
]
